(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lrlux-deal-of-day"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lrlux-deal-end]').forEach((el) => {
    const target = new Date(el.dataset.lrluxDealEnd.replace(' ', 'T'));
    const output = el.querySelector('[data-lrlux-deal-countdown]');
    if (!output || Number.isNaN(target.getTime())) return;

    function tick() {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        output.textContent = '00:00:00';
        clearInterval(timer);
        return;
      }
      const hours = String(Math.floor(diff / 3600000)).padStart(2, '0');
      const minutes = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
      const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
      output.textContent = `${hours} : ${minutes} : ${seconds}`;
    }

    tick();
    const timer = setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrlux-header"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-lrlux-menu-open]')) {
      document.body.classList.add('lrlux-menu-open');
      const btn = event.target.closest('[data-lrlux-menu-open]');
      if (btn) btn.setAttribute('aria-expanded', 'true');
    }
    if (event.target.closest('[data-lrlux-menu-close]')) {
      document.body.classList.remove('lrlux-menu-open');
      document.querySelectorAll('[data-lrlux-menu-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
    }

    // Desktop nav dropdowns (.lrlux-nav__panel, <details>/<summary>) —
    // native <details> only toggles on its own summary, it never closes
    // itself on an outside click. Close any that aren't the ancestor of
    // whatever was just clicked.
    document.querySelectorAll('.lrlux-nav details[open]').forEach((details) => {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.body.classList.remove('lrlux-menu-open');
      document.querySelectorAll('.lrlux-nav details[open]').forEach((details) => {
        details.removeAttribute('open');
      });
    }
  });

  // .lrlux-hdr__search-row (+ its --mobile twin) renders in normal flow
  // by default — it has to stay visually in place, right under the menu,
  // not float at the top of the page from load. Plain CSS position:sticky
  // can't keep it pinned through a long scroll here (see the comment on
  // .lrlux-hdr__search-row in lrlux.css: Shopify wraps this whole section
  // in its own short `shopify-section` div, and sticky only holds while
  // that parent box is still on screen). This polyfills the same "stays
  // put, then sticks once scrolled to" behavior with a scroll listener:
  // record the row's natural position once, then flip position:fixed on
  // via .is-pinned only once the page has actually scrolled that far.
  // Only one of the two rows (mobile/desktop) is ever visible at a time
  // (CSS toggles between them at the 768px breakpoint) — checked here via
  // computed display, NOT offsetParent: offsetParent is null both for a
  // display:none element AND for a position:fixed one. Using it here
  // meant that the instant a row got pinned (fixed), activeRow() could no
  // longer find it at all — onScroll() then bailed out on every
  // subsequent tick via its `if (!row) return`, permanently freezing
  // that row in the pinned state with no way to ever unpin it again
  // (the exact "stuck at the top instead of back in place" bug).
  (function () {
    var spacer = document.querySelector('.lrlux-hdr__search-row-spacer');
    var naturalTop = null;

    function activeRow() {
      var rows = document.querySelectorAll('.lrlux-hdr__search-row');
      for (var i = 0; i < rows.length; i++) {
        if (getComputedStyle(rows[i]).display !== 'none') return rows[i];
      }
      return null;
    }

    function measure() {
      document.querySelectorAll('.lrlux-hdr__search-row').forEach(function (row) {
        row.classList.remove('is-pinned');
      });
      if (spacer) spacer.style.height = '0px';
      var row = activeRow();
      naturalTop = row ? row.getBoundingClientRect().top + window.pageYOffset : null;
    }

    function onScroll() {
      var row = activeRow();
      if (!row || naturalTop === null) return;
      var shouldPin = window.pageYOffset >= naturalTop;
      var isPinned = row.classList.contains('is-pinned');
      if (shouldPin && !isPinned) {
        if (spacer) spacer.style.height = row.offsetHeight + 'px';
        row.classList.add('is-pinned');
      } else if (!shouldPin && isPinned) {
        row.classList.remove('is-pinned');
        if (spacer) spacer.style.height = '0px';
      }
    }

    window.addEventListener('load', measure);
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', onScroll, { passive: true });
    measure();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lrlux-hero"] && !Shopify.designMode) return;
  try {
    
  class LrluxHero extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-lrlux-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-lrlux-hero-dot]'));
      this.prevBtn = this.querySelector('[data-lrlux-hero-prev]');
      this.nextBtn = this.querySelector('[data-lrlux-hero-next]');
      this.current = 0;
      this.interval = (parseInt(this.dataset.interval, 10) || 6) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.syncMedia();

      if (this.slides.length < 2) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.goTo(parseInt(dot.dataset.lrluxHeroDot, 10));
          this.resetAutoplay();
        });
      });

      this.prevBtn && this.prevBtn.addEventListener('click', () => {
        this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
        this.resetAutoplay();
      });
      this.nextBtn && this.nextBtn.addEventListener('click', () => {
        this.goTo((this.current + 1) % this.slides.length);
        this.resetAutoplay();
      });

      let touchStartX = 0;
      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const delta = e.changedTouches[0].screenX - touchStartX;
        if (Math.abs(delta) < 40) return;
        if (delta < 0) {
          this.goTo((this.current + 1) % this.slides.length);
        } else {
          this.goTo((this.current - 1 + this.slides.length) % this.slides.length);
        }
        this.resetAutoplay();
      }, { passive: true });

      this.startAutoplay();
    }

    goTo(index) {
      if (!this.slides[index]) return;
      this.slides[this.current].classList.remove('lrlux-hero__slide--active');
      this.dots[this.current] && this.dots[this.current].classList.remove('lrlux-hero__dot--active');
      this.current = index;
      this.slides[this.current].classList.add('lrlux-hero__slide--active');
      this.dots[this.current] && this.dots[this.current].classList.add('lrlux-hero__dot--active');
      this.syncMedia();
    }

    syncMedia() {
      this.slides.forEach((slide, index) => {
        const active = index === this.current;
        const video = slide.querySelector('video');
        const embed = slide.querySelector('[data-lrlux-hero-embed]');
        const wantsAutoplay = !this.reducedMotion && slide.dataset.videoAutoplay === 'true';

        if (video) {
          const wantsSound = slide.dataset.videoMuted === 'false';
          if (active && wantsAutoplay) {
            video.muted = !wantsSound;
            video.play().catch(() => {
              video.muted = true;
              video.play().catch(() => {});
              this.unmuteOnInteraction();
            });
          } else {
            video.pause();
          }
        }

        if (embed) {
          if (active) {
            if (!embed.getAttribute('src')) embed.setAttribute('src', embed.dataset.lrluxHeroEmbed);
            if (slide.dataset.videoMuted === 'false') this.unmuteOnInteraction();
          } else if (embed.getAttribute('src')) {
            embed.removeAttribute('src');
          }
        }
      });
    }

    unmuteOnInteraction() {
      if (this.unmuteBound) return;
      this.unmuteBound = true;
      const events = ['pointerdown', 'keydown', 'touchstart'];
      const handler = () => {
        events.forEach((name) => document.removeEventListener(name, handler, true));
        this.unmuteBound = false;
        const slide = this.slides[this.current];
        if (!slide || slide.dataset.videoMuted !== 'false') return;
        const video = slide.querySelector('video');
        const embed = slide.querySelector('[data-lrlux-hero-embed]');
        if (video) video.muted = false;
        if (embed && embed.contentWindow) {
          embed.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'unMute', args: [] }), '*');
        }
      };
      events.forEach((name) => document.addEventListener(name, handler, true));
    }

    startAutoplay() {
      clearTimeout(this.timer);
      const seconds = parseInt(this.slides[this.current].dataset.duration, 10);
      const delay = seconds > 0 ? seconds * 1000 : this.interval;
      this.timer = setTimeout(() => {
        this.goTo((this.current + 1) % this.slides.length);
        this.startAutoplay();
      }, delay);
    }

    resetAutoplay() {
      this.startAutoplay();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
    }
  }

  customElements.define('lrlux-hero', LrluxHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-lrlux"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const stepBtn = event.target.closest('[data-lrlux-cart-step]');
    if (stepBtn) {
      const line = stepBtn.closest('[data-lrlux-cart-line]');
      const qtyEl = line.querySelector('[data-lrlux-cart-qty]');
      const delta = parseInt(stepBtn.dataset.lrluxCartStep, 10);
      const newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);
      lrluxCartChange(line.dataset.key, newQty);
    }

    const removeBtn = event.target.closest('[data-lrlux-cart-remove]');
    if (removeBtn) {
      const line = removeBtn.closest('[data-lrlux-cart-line]');
      lrluxCartChange(line.dataset.key, 0);
    }

    const applyBtn = event.target.closest('[data-lrlux-apply-discount]');
    if (applyBtn) {
      const input = document.getElementById('lrlux-discount-code');
      const code = input && input.value.trim();
      if (code) {
        window.location.href = `${window.Shopify.routes.root}discount/${encodeURIComponent(code)}?redirect=/cart`;
      }
    }
  });

  function lrluxCartChange(key, quantity) {
    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(() => window.location.reload())
      .catch(() => window.location.reload());
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    


  function ensureLegacyAjaxStubs(productFormEl) {
    try {
      const formEl = productFormEl && productFormEl.querySelector ? productFormEl.querySelector('form') : null;
      if (!formEl) return null;

      // .ajax-submit button used by app.js click handler
      let ajaxSubmit = formEl.querySelector('.ajax-submit');
      if (!ajaxSubmit) {
        ajaxSubmit = document.createElement('button');
        ajaxSubmit.type = 'button';
        ajaxSubmit.className = 'ajax-submit';
        ajaxSubmit.style.display = 'none';
        const span = document.createElement('span');
        ajaxSubmit.appendChild(span);
        formEl.appendChild(ajaxSubmit);
      }

      // .add_to_cart button used by app.js to disable/change text
      let addToCart = formEl.querySelector('.add_to_cart');
      if (!addToCart) {
        addToCart = document.createElement('button');
        addToCart.type = 'button';
        addToCart.className = 'add_to_cart';
        addToCart.style.display = 'none';
        addToCart.setAttribute('data-label', (window.PXUTheme && window.PXUTheme.translation && window.PXUTheme.translation.product_add_to_cart) || 'Add to cart');
        const span = document.createElement('span');
        span.textContent = addToCart.getAttribute('data-label');
        addToCart.appendChild(span);
        formEl.appendChild(addToCart);
      }

      return { formEl, ajaxSubmit, addToCart };
    } catch (_) {
      return null;
    }
  }

  document.addEventListener('product-form:cart:navigate', (event) => {
    try {
      const action = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';

      if (action === 'ajax') {
        event.preventDefault();
      } else if (action === 'reload_page') {
        event.preventDefault();
        window.location.reload();
      } else if (action === 'redirect_checkout') {
        event.preventDefault();
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = `${root}checkout`;
      }
    } catch (_) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:cart:request', (event) => {
    try {
      const action = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';
      if (action !== 'ajax') return;

      event.preventDefault();

      const stubs = ensureLegacyAjaxStubs(event.target);
      if (!stubs || !stubs.ajaxSubmit) return;

      const pf = event.target;
      if (window.jQuery) {
        const $doc = window.jQuery(document);
        const cleanup = () => { $doc.off('.hvAjaxBridge'); };
        const successHandler = function(e, jqXHR, ajaxSettings, data) {
          try {
            if (ajaxSettings && typeof ajaxSettings.url === 'string' && ajaxSettings.url.indexOf('/cart/add.js') !== -1) {
              cleanup();
              let item = data || (jqXHR && (jqXHR.responseJSON));
              if (!item && jqXHR && jqXHR.responseText) {
                try { item = JSON.parse(jqXHR.responseText); } catch (_) {}
              }
              if (pf && typeof pf.resolveCartRequest === 'function') {
                pf.resolveCartRequest(item);
              }
            }
          } catch (err) {
            cleanup();
            if (pf && typeof pf.rejectCartRequest === 'function') {
              pf.rejectCartRequest(err);
            }
          }
        };
        const errorHandler = function(e, jqXHR, ajaxSettings, thrownError) {
          if (ajaxSettings && typeof ajaxSettings.url === 'string' && ajaxSettings.url.indexOf('/cart/add.js') !== -1) {
            cleanup();
            if (pf && typeof pf.rejectCartRequest === 'function') {
              pf.rejectCartRequest(thrownError || jqXHR);
            }
          }
        };
        $doc.on('ajaxSuccess.hvAjaxBridge', successHandler);
        $doc.on('ajaxError.hvAjaxBridge', errorHandler);
      }

      if (window.jQuery) {
        window.jQuery(stubs.ajaxSubmit).trigger('click');
      } else {
        stubs.ajaxSubmit.click();
      }
    } catch (_) {}
  });

  document.addEventListener('product-form:message:success', (e) => {
    try {
      const action = (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';
      if (action === 'ajax') {
        e.preventDefault();
      }
    } catch (_) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-lrlux"] && !Shopify.designMode) return;
  try {
    
  function lrluxCartAction() {
    return (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.cart_action) || 'ajax';
  }

  // Never let form.product redirect to /cart — the floating cart (or the
  // ajax refresh) already reflects the updated state in place.
  document.addEventListener('product-form:cart:navigate', (event) => {
    const action = lrluxCartAction();
    if (action === 'ajax' || action === 'floating') {
      event.preventDefault();
    } else if (action === 'reload_page') {
      event.preventDefault();
      window.location.reload();
    } else if (action === 'redirect_checkout') {
      event.preventDefault();
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      window.location.href = `${root}checkout`;
    }
  });

  // When the floating cart is active, hand the add-to-cart request to its
  // own public API (assets/floating-cart.js) instead of letting
  // form.product do its own fetch — this is the same window.addToFloatingCart
  // call used by snippets/floating-cart-integration.liquid for the Home
  // product cards, so the "fly to cart" animation (no drawer opening)
  // behaves identically everywhere.
  document.addEventListener('product-form:cart:request', (event) => {
    if (lrluxCartAction() !== 'floating') return;

    event.preventDefault();

    try {
      const formData = event.detail.form;
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity'), 10) || 1;

      if (variantId && window.addToFloatingCart) {
        // deferCartAnimation: assets/product-to-cart-animation.js runs its own
        // flying-image animation + confirmation pulse on product-form:submit:success
        // (dispatched below once this promise resolves) — skip floating-cart.js's
        // own ball/pulse so they don't both play for the same add.
        window.addToFloatingCart(variantId, quantity, { deferCartAnimation: true })
          .then((responseData) => {
            if (typeof event.detail.resolve === 'function') {
              event.detail.resolve(responseData || {});
            }
          })
          .catch((error) => {
            if (typeof event.detail.reject === 'function') {
              event.detail.reject(error);
            }
          });
      } else if (typeof event.detail.reject === 'function') {
        event.detail.reject(new Error('Floating cart is not available'));
      }
    } catch (error) {
      if (typeof event.detail.reject === 'function') {
        event.detail.reject(error);
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
